import script from "./imageDynamicEffects.vue?vue&type=script&setup=true&lang=js"
export * from "./imageDynamicEffects.vue?vue&type=script&setup=true&lang=js"

import "./imageDynamicEffects.vue?vue&type=style&index=0&id=2742947b&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2742947b"]])

export default __exports__